const ComponentsLookup = {
  "default-footer": "DefaultFooter8ad4eb17Bfd7425188d16f415901827c"
}

export default ComponentsLookup;